import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {environment} from '../../../environments/environment';

@Injectable()
export class ComunicadosService {
  private apiUrl = environment.angularJSconstants.URLAPICLIENTE;
  constructor(private http: HttpClient) {}

  public setAceiteComunicado(data: any): Promise<string> {
    try {
      const token = localStorage.getItem('ls.token').replace(/"/g, '');

      if (token) {
        const headers = new HttpHeaders({
          'Authorization': token,
        });

        return this.http
          .post<string>(`${this.apiUrl}/comunicados/aceite`, data, {
            headers,
            responseType: 'text' as 'json',
          })
          .toPromise();
      }
    } catch (error) {}
  }

  public getComunicadosAtivos(): Promise<any> {
    try {

      const token = localStorage.getItem('ls.token').replace(/"/g, '');

      if (token) {
        const headers = new HttpHeaders({
          'Authorization': token,
        });

        return this.http.get<any>(`${this.apiUrl}/comunicados/ativos`, {headers}).toPromise();
      }
    } catch (error) {
      console.log(error);
    }
  }
}
